export default {
	pricing: {
		title: 'Subscription Plans',
		subtitle: 'Choose the plan that works best for you',
		noPlans: 'No Plans Available',
		noPlansDescription:
			'Subscription plans are not currently available. Please check back later.',
		signInToSubscribe: 'Sign In to Subscribe',
		subscribe: 'Subscribe',
		allFeatures: 'All features included',
		disabledTitle: 'Billing Unavailable',
		disabledDescription:
			'Subscriptions are currently disabled. Please check back later.',
	},
	upgradeMoment: {
		facet: {
			title: 'Create your own facets of this topic',
			body: 'Facets give each topic another angle — an in-depth read, a glossary, cards to make it stick. With Pro you create them on any route and make what you learn your own.',
			titleWithContext: 'Create your own facets of "{{name}}"',
			bodyWithContext:
				'Facets give "{{name}}" another angle — an in-depth read, a glossary, cards to make it stick. With Pro you create them on any route and make what you learn your own.',
		},
		resources: {
			title: 'Gather the resources for this topic',
			body: 'Pro pulls together videos, articles and references to extend each topic, on any of your routes — so a topic becomes your working material, not just a starting point.',
			titleWithContext: 'Gather the resources for "{{name}}"',
			bodyWithContext:
				'Pro pulls together videos, articles and references to extend "{{name}}" and any other topic on your routes — so a topic becomes your working material, not just a starting point.',
		},
		generic: {
			title: 'Go further with this topic',
			body: 'Pro unlocks the tools to turn each topic into criteria you can apply: new facets and curated resources, on any route.',
		},
		budget: {
			title: 'Your free routes are in use',
			body: 'Everything you started stays available. With Pro you open any route or program in the catalog and keep building criteria without pauses.',
			titleWithContext: 'Continue with "{{name}}" on Pro',
			bodyWithContext:
				'Your free routes are in use and everything you started stays available. With Pro you open "{{name}}" and any other route or program in the catalog.',
		},
		primaryCta: 'Upgrade to Pro',
		secondaryCta: 'Not now',
	},
	degustacion: {
		includedFree: 'Included free',
	},
	success: {
		title: 'Payment Successful!',
		description:
			'Thank you for subscribing. Your payment has been processed successfully.',
		processingDescription:
			'Your payment is confirmed, and we are activating your subscription.',
		processingNote:
			'This usually takes a few seconds. Refresh this page if your subscription does not appear shortly.',
		whatNext: "What's Next?",
		accessGranted: 'Your subscription is now active',
		emailConfirmation: 'You will receive a confirmation email shortly',
		fullAccess: 'You now have full access to all subscription features',
		goToDashboard: 'Go to Dashboard',
		manageSubscription: 'Manage Subscription',
	},
	cancel: {
		title: 'Payment Canceled',
		description:
			'Your payment was canceled. No charges have been made to your account.',
		needHelp: 'Need Help?',
		contactSupport:
			'If you encountered an issue during checkout or have questions about our plans, please contact our support team.',
		tryAgain: 'Try Again',
		backToDashboard: 'Back to Dashboard',
	},
	settings: {
		title: 'Billing',
		description: 'Manage your subscription and payment methods',
		subscriptionStatus: 'Subscription Status',
		subscriptionDescription: 'View and manage your subscription details',
		noSubscription: 'You do not have an active subscription',
		viewPlans: 'View Plans',
		plan: 'Plan',
		amount: 'Amount',
		endsOn: 'Subscription Ends On',
		renewsOn: 'Renews On',
		gracePeriod: 'Your subscription has been canceled and will end on {date}',
		manageSubscription: 'Manage Subscription',
		portalDescription:
			'Update payment methods, view invoices, and manage your subscription',
		customerPortal: 'Customer Portal',
		openPortal: 'Open portal in a new tab',
		portalMissingToken:
			'Billing portal is not configured yet. Please contact support or try again later.',
		portalError:
			'We could not load the billing portal. Please try again later.',
		portalUnavailable: 'Billing portal is currently unavailable.',
		statuses: {
			active: 'Active',
			trialing: 'Trialing',
			past_due: 'Past due',
			canceled: 'Canceled',
			incomplete: 'Incomplete',
		},
	},
	banner: {
		subscriptionCanceled: 'Subscription Canceled',
		accessEndsOn:
			'Your access will end on {date} ({days} {days, plural, one {day} other {days}} remaining).',
		reactivate: 'Reactivate Subscription',
		manageSubscription: 'Manage Subscription',
		paymentPastDue: 'Payment Past Due',
		paymentPastDueDescription:
			'Your payment is past due. Please update your payment method to avoid service interruption.',
		updatePayment: 'Update Payment Method',
		trialEnding: 'Trial Ending Soon',
		trialEndingDescription:
			'Your trial ends on {date} ({days} {days, plural, one {day} other {days}} remaining).',
		viewBilling: 'View Billing Details',
	},
	accessGate: {
		subscriptionRequired: 'Subscription Required',
		subscriptionRequiredDescription:
			'This course requires an active subscription to access.',
		whySubscription: 'Why Subscribe?',
		benefit1: 'Unlimited access to all subscription courses',
		benefit2: 'New courses added regularly',
		benefit3: 'Cancel anytime',
		viewPlans: 'View Plans',
		upgradeNow: 'Upgrade now',
		backToDashboard: 'Back to Dashboard',
		enrollmentRequired: 'Enrollment Required',
		enrollmentRequiredDescription:
			'You need to enroll in "{courseName}" to access this course.',
		enrollmentNote:
			'You have an active subscription, but you need to enroll in this course to access its content.',
		enrollNow: 'Enroll Now',
		signInRequired: 'Sign In Required',
		signInRequiredDescription: 'Please sign in to access this course.',
		signIn: 'Sign In',
		createAccount: 'Create Account',
		accessDenied: 'Access Denied',
		accessDeniedDescription:
			'You do not have permission to access this course.',
	},
}
